import appAxios from "./axios";
/*
    For CRUD
*/
export class AuthService {
  static createUser(data) {
    return appAxios.post("/auth/signup", data);
  }

  static login(user) {
    return appAxios.post("/auth/sign", user);
  }

  static loginWithPhone(phone, password) {
    return appAxios.post("/auth/phone/sign", { phone, password });
  }

  static signInWithGoogle(user, accessToken) {
    return appAxios.post("/auth/google", {
      user,
      accessToken,
    });
  }
}
